import {EmployeesEntity} from "~/config/pages/reports/api-types";
import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@material-ui/core";
import React from "react";

export function IllegalTracking(props: { data: EmployeesEntity[] }) {
  let items = props.data;

  return (
    <TableContainer component={Paper}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Username</TableCell>
            <TableCell align="right">Заказ</TableCell>
            <TableCell align="right">Описание заказа</TableCell>
            <TableCell align="right">Номер задачи</TableCell>
            <TableCell align="right">Описание задачи</TableCell>
            <TableCell align="right">Дата</TableCell>
            <TableCell align="right">Часов</TableCell>
            <TableCell align="right">Слот автора</TableCell>
            <TableCell align="right">Слот заказа</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.flatMap((employee) => {
            return employee.illegalOrderTracking.map(track =>
              (
                <TableRow key={employee.username + track.worklog.id}>
                  <TableCell component="th" scope="row">{employee.username}</TableCell>
                  <TableCell align="right">
                    <a
                      href={window.location.protocol + "//" + window.location.host + "/orders/" + track.order.id + "/summary"}
                      target="_blank">
                      {track.order.number}
                    </a>
                  </TableCell>
                  <TableCell align="right">{track.order.description}</TableCell>
                  <TableCell align="right">{track.worklog.issueKey}</TableCell>
                  <TableCell align="right">{track.worklog.issueSummary}</TableCell>
                  <TableCell align="right">{track.worklog.date}</TableCell>
                  <TableCell align="right">{track.worklog.hours.toFixed(2)}</TableCell>
                  <TableCell align="right">{track.authorSlot?.name ?? "-"}</TableCell>
                  <TableCell align="right">{track.orderSlot.name}</TableCell>
                </TableRow>
              )
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
